import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '@tech-services/common.service';

@Component({
  selector: 'tech-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
})
export class StepComponent implements OnInit {
  public step: string;
  public updateData: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.commonService.showMenuSource.next(false);
    this.step = this.route.snapshot.paramMap.get('step');
  }

  public convertInt(val) {
    return parseInt(val);
  }
}
